import { Reducer } from '@reduxjs/toolkit';

const snackbarIDReducer: Reducer = (
  state, { payload },
) => ({
  ...state,
  snackbarID: payload,
});

export default snackbarIDReducer;
